import React, { useEffect, useState } from 'react'
import {
  List,
  Datagrid,
  TextField,
  TextInput,
  useTranslate,
  useResourceContext,
  useResourceDefinitions,
  useListController,
  useStore,
  FunctionField,
  DateField,
} from 'react-admin'
import { Container } from '@mui/material'
import { CardCommon } from 'src/components/uiElements'
import { ListViewActionsButtons } from 'src/components/uiElements/buttons/ListViewActionsButtons'
import { ListViewTopToolbar } from 'src/components/uiElements/CRUD/ListViewTopToolbar'
import {
  PostFilterButtonLanding,
  PostFilterFormLanding,
} from 'src/components/pages/marketing/landing/LandingFilter'

export const LandingList = (props) => {
  const translate = useTranslate()
  const { setSort, isFetching } = useListController()
  const [isSorting, setIsSorting] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [permissionsStore, setPermissionsStore] = useStore('currentResource', '{}')
  const [permissions, setPermissions] = useState(null)
  const propsResource = useResourceDefinitions()
  const resourceName = useResourceContext()

  useEffect(() => {
    setPermissionsStore(JSON.stringify(propsResource[resourceName]))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [propsResource, resourceName])

  useEffect(() => {
    if (permissionsStore) {
      setPermissions(JSON.parse(permissionsStore))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [permissionsStore])

  useEffect(() => {
    if (isSorting && isFetching) {
      setIsLoading(true)
    } else if (isLoading && isSorting && !isFetching) {
      setIsLoading(false)
      setIsSorting(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSorting, isFetching])

  const onClickSort = (sort) => {
    setSort(sort)
    setIsSorting(true)
  }

  const hasPermissions = () => {
    return (
      permissions?.options?.revision ||
      permissions?.hasShow ||
      permissions?.hasEdit ||
      permissions?.options?.delete
    )
  }

  const allFilters = [
    { source: 'short_name', name: 'ra.field.short_name' },
    { source: 'business_unit_id__in', name: 'ra.field.business_unit' },
    { source: 'work_unit_id__in', name: 'ra.field.work_unit' },
    { source: 'datetime', name: 'ra.field.date' },
  ]

  return (
    <Container className='content'>
      <CardCommon title={translate('ra.entity.landing')}>
        <List
          {...props}
          component='div'
          actions={
            <ListViewTopToolbar
              hasCreate={permissions?.hasCreate}
              FilterButtonComponent={PostFilterButtonLanding}
              FilterFormComponent={PostFilterFormLanding}
              listFilters={allFilters}
            />
          }
        >
          <Datagrid rowClick='show' setSort={onClickSort} isLoading={isLoading}>
            <TextField source='id' label={translate('ra.field.id')} />
            <TextField source='short_name' label={translate('ra.field.short_name')} />
            <FunctionField
              label={translate('ra.field.work_unit')}
              render={(record) => {
                return record?.work_unit_short_names?.join(', ') || '-'
              }}
            />
            <FunctionField
              label={translate('ra.field.business_unit')}
              render={(record) => {
                return record?.business_unit?.join(', ') || '-'
              }}
            />

            <DateField label={translate('ra.field.datetime_from')} source='datetime_from' />
            <DateField label={translate('ra.field.datetime_to')} source='datetime_to' />
            {hasPermissions() && (
              <ListViewActionsButtons
                label={translate('ra.action.actions')}
                fieldsName={['short_name']}
                genderElement='masculine'
                disableRevision
                clone={true}
              />
            )}
          </Datagrid>
        </List>
      </CardCommon>
    </Container>
  )
}
